// Finding lifecycle. New → Needs action → In progress → Resolved; Dismissed from New or Needs action.
// A resolved finding seen again reopens as New (history kept by the API).
import type { FindingStatus } from './types';

const NEXT: Record<FindingStatus, FindingStatus[]> = {
  new: ['needs_action', 'dismissed', 'in_progress', 'resolved'],
  needs_action: ['in_progress', 'resolved', 'dismissed'],
  in_progress: ['resolved', 'needs_action'], // needs_action when a partner request needs the user
  resolved: ['new'],
  dismissed: ['new'],
};
export const canMove = (from: FindingStatus, to: FindingStatus) => NEXT[from].includes(to);
export const isOpen = (s: FindingStatus) => s === 'new' || s === 'needs_action' || s === 'in_progress';
